var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 91,
    viewBox: "0 0 167 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_139_4965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.5423 0H19.0187C8.53738 0 0 8.4803 0 18.8916V59.4418C0 69.853 8.53738 78.3333 19.0187 78.3333H29.6804V93.8407C29.6804 95.4134 30.5823 96.8666 32.0052 97.5633C32.5863 97.842 33.2276 97.9814 33.8489 97.9814C34.7508 97.9814 35.6325 97.7027 36.3741 97.1254L50.082 86.7539V61.9102C50.082 59.1232 50.5028 56.4358 51.3045 53.9077H25.051C22.7463 53.9077 20.8825 52.0563 20.8825 49.767C20.8825 47.4778 22.7463 45.6264 25.051 45.6264H55.6132C60.6034 39.0174 68.5395 34.7175 77.4777 34.7175H108.561V18.8916C108.541 8.4803 100.004 0 89.5223 0H89.5423ZM83.51 33.1648H25.051C22.7463 33.1648 20.8825 31.3134 20.8825 29.0241C20.8825 26.7349 22.7463 24.8835 25.051 24.8835H83.51C85.8147 24.8835 87.6785 26.7349 87.6785 29.0241C87.6785 31.3134 85.8147 33.1648 83.51 33.1648Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.981 43H77.4777C66.9964 43 58.459 51.4803 58.459 61.8916V102.442C58.459 112.853 66.9964 121.333 77.4777 121.333H105.795L130.606 140.145C131.347 140.723 132.249 141.001 133.131 141.001C133.772 141.001 134.394 140.862 134.975 140.583C136.398 139.886 137.299 138.453 137.299 136.861V121.353H147.961C158.443 121.353 166.98 112.873 166.98 102.462V61.9115C166.98 51.5002 158.443 43.0199 147.961 43.0199L147.981 43ZM129.423 95.3748H83.4899C81.1853 95.3748 79.3215 93.5235 79.3215 91.2342C79.3215 88.9449 81.1853 87.0936 83.4899 87.0936H129.423C131.728 87.0936 133.592 88.9449 133.592 91.2342C133.592 93.5235 131.728 95.3748 129.423 95.3748ZM141.949 74.6518H83.4899C81.1853 74.6518 79.3215 72.8005 79.3215 70.5112C79.3215 68.2219 81.1853 66.3706 83.4899 66.3706H141.949C144.254 66.3706 146.117 68.2219 146.117 70.5112C146.117 72.8005 144.254 74.6518 141.949 74.6518Z",
    fill: "#00A90B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_139_4965",
    x: 0,
    y: 0,
    width: 166.979,
    height: 145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_139_4965"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert1);
export default __webpack_public_path__ + "static/media/alert1.28fe9174ba13b0e742a79e8edf91ada2.svg";
export { ForwardRef as ReactComponent };